import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import { Icon } from "../components/common/Icon";
import {
  DEFAULT_LADDER_CONFIG,
  LadderConfigFields,
  type LadderConfigValues,
} from "../components/ladders/LadderConfigForm";
import { useCreateLadder } from "../hooks/mutations/useLadderMutations";

function NewLadder() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const create = useCreateLadder();

  const [config, setConfig] = useState<LadderConfigValues>(DEFAULT_LADDER_CONFIG);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    const created = await create.mutateAsync({
      ...config,
      nameCs: config.nameCs.trim(),
      nameEn: config.nameEn.trim(),
    });
    navigate(`/ladders/${created.id}`);
  };

  const canSubmit = config.nameCs.trim().length > 0 && config.nameEn.trim().length > 0 && !create.isPending;

  return (
    <div className="base-container">
      <div className="table-header header">
        <span className="table-title">{t("createLadder")}</span>
      </div>
      <div className="content">
        <div className="new-ladder-wrapper">
          <Card className="new-ladder-card">
            <Card.Body>
              <p className="new-ladder-intro">{t("newLadderIntro")}</p>
              <div className="new-ladder-hint">
                <Icon name="InfoCircle" className="new-ladder-hint-icon" />
                <span>{t("newLadderNoLadderHint")}</span>
              </div>

              <Form onSubmit={submit} className="mt-4">
                <LadderConfigFields
                  value={config}
                  onChange={(patch) => setConfig((c) => ({ ...c, ...patch }))}
                  idPrefix="newLadder"
                  autoFocusName
                />

                <div className="new-ladder-actions">
                  <Button
                    variant="outline-secondary"
                    onClick={() => navigate(-1)}
                    type="button"
                  >
                    {t("cancel")}
                  </Button>
                  <Button type="submit" variant="success" disabled={!canSubmit}>
                    {t("createLadder")}
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default NewLadder;
